import React, { useState } from 'react';
import StudentListComponent from '../components/studentList';
function StudentList() {
    return <StudentListComponent />;
}

export default StudentList;
